import React from 'react';




const Pagination = ({ currentPage, onPageChange, pageSize, totalItems, start, t, recordsFiltered }: any) => {
  const handlePageChange = (pageNumber: any) => {
      onPageChange(pageNumber);
  };

  // Number of pages to show before and after the ellipsis
  const pagesToShow = 3;
  const totalPages = Math.ceil(totalItems / pageSize);
  const renderPageNumbers = () => {

    const pageNumbers: any = [];
    // Render the pages before and after the current page
    for (let page = currentPage - pagesToShow; page <= currentPage + pagesToShow; page++) {
      if (page > 0 && page <= totalPages) {
        pageNumbers.push(
          <li key={page} className={currentPage === page ? "page-item active" : "page-item"}>
            <a

              onClick={() => handlePageChange(page)}
              className="page-link fs-7"
            >
              {page}
            </a>
          </li>
        );
      }
    }
    return pageNumbers;
  };
if(isNaN(recordsFiltered))
  recordsFiltered=totalItems;
  const end = Math.min( Number(start) + Number(pageSize), recordsFiltered);
  

  return (
    <>
      <div className="d-flex align-items-center">
        {/* Showing 1 to 10 of 333 entries (filtered from 55,549 total entries) */}
        {(recordsFiltered !== totalItems) ?
          
          <span className="fw-normal fs-7" style={{ color: '#172b4d' }} > {start+1} - {end}  {t ? t('of') : 'of'} {recordsFiltered} {t ? t('entries') : 'entries'} ({t('filtered from')}  {totalItems}  {t('total')} {t('entries')})</span>
          // <span className="fw-normal fs-7" style={{ color: '#172b4d' }} > {start + 1} - {start + pageSize}  {t ? t('of') : 'of'} {recordsFiltered} {t ? t('entries') : 'entries'} ({t('filtered from')}  {totalItems}  {t('total')} {t('entries')})</span>
          :
          // <span className="fw-normal fs-7" style={{ color: '#172b4d' }} > {start + 1} - {start + pageSize}  {t ? t('of') : 'of'} {totalItems}</span>
          <span className="fw-normal fs-7" style={{ color: '#172b4d' }} > {start+1} - {end}   {t ? t('of') : 'of'} {totalItems}</span>
        }
        <ul className="pagination">
          <li className="page-item previous" style={currentPage === 1 ? { pointerEvents: 'none', marginRight: '0px', marginLeft: '5px' } : { pointerEvents: 'initial', marginRight: '0px', marginLeft: '5px' }} onClick={() => handlePageChange(currentPage - 1)}  >
            <a className="page-link" style={{
              borderTopRightRadius: '0px',
              borderBottomRightRadius: '0px',
              borderTopLeftRadius: '5px',
              borderBottomLeftRadius: '5px',
            }}>
              <i className="previous" ></i>
            </a>
          </li>
          {/* {renderPageNumbers()}
          {currentPage < totalPages - pagesToShow - 1 ? (<li key="ellipsis" className="ellipsis">...</li>) : null} */}
          {recordsFiltered ?
            <li className="page-item next" style={(currentPage * pageSize >= recordsFiltered) ? { pointerEvents: 'none' } : { pointerEvents: 'initial' }} onClick={() => handlePageChange(currentPage + 1)} >
              <a className="page-link" style={{
                borderTopLeftRadius: '0px',
                borderBottomLeftRadius: '0px',
                borderTopRightRadius: '5px',
                borderBottomRightRadius: '5px',
              }}>
                <i className="next"></i>
              </a>
            </li>
            :
            <li className="page-item next" style={(currentPage * pageSize >= totalItems) ? { pointerEvents: 'none' } : { pointerEvents: 'initial' }} onClick={() => handlePageChange(currentPage + 1)} >
              <a className="page-link" style={{
                borderTopLeftRadius: '0px',
                borderBottomLeftRadius: '0px',
                borderTopRightRadius: '5px',
                borderBottomRightRadius: '5px',
              }}>
                <i className="next"></i>
              </a>
            </li>
          }
        </ul>
      </div>
    </>
  );
};

export default Pagination;



{/* <div className='row'>
        <div className='col-md-6'>
          <span className="text-muted">Showing {start + 1} to {start + pageSize} of {totalItems} entries</span>
        </div>
        <div className='col-md-6'>
          <ul className="pagination" style={{justifyContent:'right'}}>
            <li className="page-item previous" style={currentPage === 1 ? { pointerEvents: 'none' } : { pointerEvents: 'initial' }} onClick={() => handlePageChange(currentPage - 1)}  >
              <a className="page-link">
                <i className="previous"></i>
              </a>
            </li>
           
            {renderPageNumbers()}
           
            {currentPage < totalPages - pagesToShow - 1 ? (<li key="ellipsis" className="ellipsis">...</li>) : null}

            <li className="page-item next" style={(currentPage * pageSize >= totalItems) ? { pointerEvents: 'none' } : { pointerEvents: 'initial' }} onClick={() => handlePageChange(currentPage + 1)} >
              <a className="page-link">
                <i className="next"></i>
              </a>
            </li>
          </ul>
        </div>

      </div> */}
